/**
 * This method takes a URL without protocol and host and
 * builds a fake full url to parse and return just the pathname
 * without query strings or fragments
 */

export function getPathnameFromPartialURL(requestUrl: string): string {
  const { pathname } = new URL('http://url-mock' + requestUrl);
  return pathname;
}
